import { Action, createReducer, on } from "@ngrx/store";
import { MovimientoTramiteState, movimientoTramiteAdapter, movimientoTramiteInitialState } from "./movimiento-tramite.state";
import { movimientoTramiteAddRequest, movimientoTramiteAddSuccess, movimientoTramiteLoadRequest, movimientoTramiteLoadSuccess } from "./movimiento-tramite.actions";

export const MOVIMIENTO_TRAMITE_FEATURE_KEY = 'movimientoTramite';

const reducer = createReducer(
  movimientoTramiteInitialState,
  on(movimientoTramiteAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(movimientoTramiteAddSuccess, (state, { item }) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(movimientoTramiteLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(movimientoTramiteLoadSuccess, (state, { items }) => {
    return movimientoTramiteAdapter.setAll(items, {
      ...state,
      isLoading: false,
      error: null
    })
  })
)

export function movimientoTramiteReducer(
  state: MovimientoTramiteState | undefined,
  action: Action
) {
  return reducer(state, action);
}
